import api from '@api';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
    createProviderConfigStructureFetchFailure,
    createProviderConfigStructureFetchSuccess,
    getProviderConfigDetailFetchFailure,
    getProviderConfigDetailFetchSuccess,
    getProviderConfigStructureFetch as getProviderConfigStructureFetchAction,
    getProviderConfigStructureFetchFailure,
    getProviderConfigStructureFetchSuccess,
    updateProviderConfigDetailFetchFailure,
    updateProviderConfigDetailFetchSuccess,
    updateProviderConfigStructureFetchFailure,
    updateProviderConfigStructureFetchSuccess
} from './reducer';
import {
    ProviderConfigDetailDataResType,
    ProviderConfigDetailFetchPayloadType,
    ProviderConfigDetailUpdatePayloadType,
    ProviderConfigStructureCreatePayloadType,
    ProviderConfigStructureFetchPayloadType,
    ProviderConfigStructureResType,
    ProviderConfigStructureUpdatePayloadType
} from 'src/types/providerConfigDetail';
import translate from '@translate';
import { SystemConfigStructureItemType } from 'src/types/systemConfigDetail';

const getProviderConfigDetailFetchRequest = async (payload: ProviderConfigDetailFetchPayloadType) => {
    const res = await api(
        'get',
        payload.system
            ? `api/secure/system-configs/provider/${payload.idProvider}/integration?system=${payload.system}`
            : `api/secure/system-configs/provider/${payload.idProvider}`
    );
    return res.data;
};

function* getProviderConfigDetailFetch(action: { type: string; payload: ProviderConfigDetailFetchPayloadType }) {
    try {
        const response: ProviderConfigDetailDataResType = yield call(() =>
            getProviderConfigDetailFetchRequest(action.payload)
        );
        yield put(
            getProviderConfigDetailFetchSuccess({
                ...response,
                request: action.payload
            })
        );
    } catch (error) {
        yield put(getProviderConfigDetailFetchFailure());
    }
}

export function* getProviderConfigDetailFetchWatch() {
    yield takeLatest('providerConfigDetail/getProviderConfigDetailFetch', getProviderConfigDetailFetch);
}

const updateProviderConfigDetailFetchRequest = async (params: ProviderConfigDetailUpdatePayloadType) => {
    const res = await api(
        'put',
        params.system
            ? `api/secure/system-configs/provider/${params.idProvider}/integration?system=${params.system}`
            : `api/secure/system-configs/provider/${params.idProvider}`,
        params.data
    );
    return res.data;
};

function* updateProviderConfigDetailFetch(action: {
    type: string;
    payload: ProviderConfigDetailUpdatePayloadType;
}) {
    try {
        const response: ProviderConfigDetailDataResType = yield call(() =>
            updateProviderConfigDetailFetchRequest(action.payload)
        );
        yield put(
            updateProviderConfigDetailFetchSuccess({
                ...response,
                request: action.payload,
                messageSuccess: { title: translate('providerConfigDetail.message.update') }
            })
        );
    } catch (error) {
        yield put(updateProviderConfigDetailFetchFailure());
    }
}

export function* updateProviderConfigDetailFetchWatch() {
    yield takeEvery('providerConfigDetail/updateProviderConfigDetailFetch', updateProviderConfigDetailFetch);
}

const getProviderConfigStructureFetchRequest = async (system?: string) => {
    const res = await api(
        'get',
        system
            ? `api/secure/system-configs/provider/integration-structure?system=${system}`
            : `api/secure/system-configs/provider/structure`
    );
    return res.data;
};

function* getProviderConfigStructureFetch(action: {
    type: string;
    payload: ProviderConfigStructureFetchPayloadType;
}) {
    try {
        const response: ProviderConfigStructureResType = yield call(() =>
            getProviderConfigStructureFetchRequest(action.payload.system)
        );
        yield put(
            getProviderConfigStructureFetchSuccess({
                ...response,
                request: action.payload
            })
        );
    } catch (error) {
        yield put(getProviderConfigStructureFetchFailure());
    }
}

export function* getProviderConfigStructureFetchWatch() {
    yield takeLatest('providerConfigDetail/getProviderConfigStructureFetch', getProviderConfigStructureFetch);
}

const createProviderConfigStructureFetchRequest = async (data: SystemConfigStructureItemType) => {
    const res = await api('post', `api/secure/system-configs/provider/structure`, data);
    return res.data;
};

function* createProviderConfigStructureFetch(action: {
    type: string;
    payload: ProviderConfigStructureCreatePayloadType;
}) {
    try {
        yield call(() => createProviderConfigStructureFetchRequest(action.payload.structureItem));
        yield put(createProviderConfigStructureFetchSuccess());
        yield put(
            getProviderConfigStructureFetchAction({
                idProvider: action.payload.idProvider,
                system: action.payload.system
            })
        );
    } catch (error) {
        yield put(createProviderConfigStructureFetchFailure());
    }
}

export function* createProviderConfigStructureFetchWatch() {
    yield takeEvery('providerConfigDetail/createProviderConfigStructureFetch', createProviderConfigStructureFetch);
}

const updateProviderConfigStructureFetchRequest = async (params: {
    id: string;
    data: SystemConfigStructureItemType;
}) => {
    const res = await api('put', `api/secure/system-configs/provider/structure/${params.id}`, params.data);
    return res.data;
};

function* updateProviderConfigStructureFetch(action: {
    type: string;
    payload: ProviderConfigStructureUpdatePayloadType;
}) {
    try {
        yield call(() => updateProviderConfigStructureFetchRequest(action.payload));
        yield put(updateProviderConfigStructureFetchSuccess());
        yield put(
            getProviderConfigStructureFetchAction({
                idProvider: action.payload.idProvider,
                system: action.payload.system
            })
        );
    } catch (error) {
        yield put(updateProviderConfigStructureFetchFailure());
    }
}

export function* updateProviderConfigStructureFetchWatch() {
    yield takeEvery('providerConfigDetail/updateProviderConfigStructureFetch', updateProviderConfigStructureFetch);
}
